// Constants
import { USER_SCHEDULE_INTERVIEW } from 'constants/routes';

/**
 * The schedule-interview flow runs its own social signup modal, so the generic
 * signup modal has to stay out of the way there — both when the user is
 * already on one of those pages and when they are being redirected back to one
 * after the social provider round-trip.
 */
export const canOpenSignUpModalForSocial = (
  pathname: string,
  redirect?: string | null
): boolean =>
  !pathname.includes(USER_SCHEDULE_INTERVIEW) &&
  !redirect?.includes(USER_SCHEDULE_INTERVIEW);
